export default __webpack_public_path__ + "static/media/paul.4fb9bd7d.jpg";